import { createContext, useContext, useEffect, useState } from 'react';
import { GetMarkets } from '../queries/Aave';

const AaveContext = createContext();

export const AaveProvider = ({ children }) => {
  const [aaveData, setAaveData] = useState({
    isLoaded: false,
    isLoading: false,
    pools: [],
    poolsObj: null,
  });

  useEffect(() => {
    if (!aaveData.isLoading && !aaveData.isLoaded) {
      GetMarkets()
        .then((data) => {
          setAaveData({
            isLoaded: true,
            pools: data.reserves,
            poolsObj: data.reservesObj,
            isLoading: false,
          });
        })
        .catch((err) => console.log(err));
      setAaveData((state) => ({ ...state, isLoading: true }));
    }
  }, [aaveData]);

  return (
    <AaveContext.Provider value={aaveData}>{children}</AaveContext.Provider>
  );
};

const useAave = () => useContext(AaveContext);

export default useAave;
